(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    /* Sort select */
    var sortSelect = document.getElementById('sort-by');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }

    /* Infinite scroll */
    var grid = document.getElementById('collection-grid');
    var loader = document.getElementById('collection-loader');
    if (!grid || !loader) return;

    var loading = false;

    function loadMore() {
      if (loading) return;
      var nextUrl = loader.getAttribute('data-next-url');
      if (!nextUrl) return;

      loading = true;

      fetch(nextUrl)
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var nextGrid = doc.getElementById('collection-grid');
          var nextLoader = doc.getElementById('collection-loader');

          if (nextGrid) {
            var items = nextGrid.children;
            while (items.length > 0) {
              grid.appendChild(items[0]);
            }
          }

          if (nextLoader && nextLoader.getAttribute('data-next-url')) {
            loader.setAttribute('data-next-url', nextLoader.getAttribute('data-next-url'));
          } else {
            loader.classList.add('collection-page__loader--done');
            loader.removeAttribute('data-next-url');
            observer.disconnect();
          }

          loading = false;
        })
        .catch(function() {
          loading = false;
        });
    }

    var observer = new IntersectionObserver(function(entries) {
      if (entries[0].isIntersecting) {
        loadMore();
      }
    }, { rootMargin: '400px' });

    observer.observe(loader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    /* --- Image slider --- */
    var sliders = document.querySelectorAll('.featured-product__slider');
    sliders.forEach(function(slider) {
      var slides = slider.querySelectorAll('.featured-product__slide');
      var dots = [];
      if (slides.length < 2) return;

      var current = 0;
      var interval = parseInt(slider.dataset.autoSlide) || 4000;
      var timer;

      function goTo(index) {
        slides[current].classList.remove('featured-product__slide--active');
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('featured-product__slide--active');
      }

      function startAuto() {
        timer = setInterval(function() { goTo(current + 1); }, interval);
      }

      function resetAuto() {
        clearInterval(timer);
        startAuto();
      }

      /* Pause on hover */
      slider.addEventListener('mouseenter', function() { clearInterval(timer); });
      slider.addEventListener('mouseleave', function() { startAuto(); });

      startAuto();
    });

    /* --- AJAX add-to-cart --- */
    var forms = document.querySelectorAll('.featured-product form[action*="/cart/add"]');
    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(form);
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.status && data.status === 422) {
            alert(data.description || 'Error');
            return;
          }
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var badges = document.querySelectorAll('.header__cart-count');
              badges.forEach(function(b) { b.textContent = cart.item_count; });
              if (cart.item_count > 0) {
                var cartLinks = document.querySelectorAll('.header__cart');
                cartLinks.forEach(function(link) {
                  if (!link.querySelector('.header__cart-count')) {
                    var span = document.createElement('span');
                    span.className = 'header__cart-count';
                    span.textContent = cart.item_count;
                    link.appendChild(span);
                  }
                });
              }
            });
          var toast = document.getElementById('cart-toast');
          if (toast) {
            toast.classList.add('cart-toast--visible');
            setTimeout(function() {
              toast.classList.remove('cart-toast--visible');
            }, 4000);
          }
        })
        .catch(function() {
          alert('Something went wrong. Please try again.');
        })
        .finally(function() {
          if (submitBtn) submitBtn.disabled = false;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    var header = document.querySelector('.header');
    if (!header) return;

    /* Mobile nav toggle */
    var mobileToggle = header.querySelector('.header__mobile-toggle');
    if (mobileToggle) {
      mobileToggle.addEventListener('click', function() {
        header.querySelector('.header__nav').classList.toggle('header__nav--open');
      });
    }

    /* Language switcher click toggle (for mobile / touch) */
    var langSwitcher = header.querySelector('.lang-switcher');
    if (langSwitcher) {
      var langCurrent = langSwitcher.querySelector('.lang-switcher__current');
      if (langCurrent) {
        langCurrent.addEventListener('click', function(e) {
          e.stopPropagation();
          langSwitcher.classList.toggle('lang-switcher--open');
        });
        document.addEventListener('click', function(e) {
          if (!langSwitcher.contains(e.target)) {
            langSwitcher.classList.remove('lang-switcher--open');
          }
        });
      }
    }

    /* Search overlay toggle */
    var searchToggle = header.querySelector('.header__search-toggle');
    var searchOverlay = header.querySelector('.header__search');
    var searchInput = header.querySelector('.header__search-input');
    var searchClose = header.querySelector('.header__search-close');

    if (searchToggle && searchOverlay) {
      searchToggle.addEventListener('click', function() {
        searchOverlay.classList.add('header__search--open');
        searchOverlay.setAttribute('aria-hidden', 'false');
        if (searchInput) searchInput.focus();
      });

      if (searchClose) {
        searchClose.addEventListener('click', function() {
          searchOverlay.classList.remove('header__search--open');
          searchOverlay.setAttribute('aria-hidden', 'true');
        });
      }

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchOverlay.classList.contains('header__search--open')) {
          searchOverlay.classList.remove('header__search--open');
          searchOverlay.setAttribute('aria-hidden', 'true');
          searchToggle.focus();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    var forms = document.querySelectorAll('.product__form form[action*="/cart/add"]');
    var toast = document.getElementById('cart-toast');
    var toastTimer;

    forms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var formData = new FormData(form);
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.status && data.status === 422) {
            alert(data.description || 'Error');
            return;
          }
          /* Update cart count in header */
          fetch('/cart.js')
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              var badges = document.querySelectorAll('.header__cart-count');
              badges.forEach(function(b) { b.textContent = cart.item_count; });
              if (cart.item_count > 0) {
                var cartLinks = document.querySelectorAll('.header__cart');
                cartLinks.forEach(function(link) {
                  if (!link.querySelector('.header__cart-count')) {
                    var span = document.createElement('span');
                    span.className = 'header__cart-count';
                    span.textContent = cart.item_count;
                    link.appendChild(span);
                  }
                });
              }
            });
          /* Show toast */
          if (toast) {
            clearTimeout(toastTimer);
            toast.classList.add('cart-toast--visible');
            toastTimer = setTimeout(function() {
              toast.classList.remove('cart-toast--visible');
            }, 4000);
          }
        })
        .catch(function() {
          alert('Something went wrong. Please try again.');
        })
        .finally(function() {
          if (submitBtn) submitBtn.disabled = false;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
